import { render, staticRenderFns } from "./mask.vue?vue&type=template&id=6319dccf&scoped=true&"
import script from "./mask.vue?vue&type=script&lang=js&"
export * from "./mask.vue?vue&type=script&lang=js&"
import style0 from "./mask.vue?vue&type=style&index=0&id=6319dccf&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6319dccf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\uniFrame\\uni-frame\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6319dccf')) {
      api.createRecord('6319dccf', component.options)
    } else {
      api.reload('6319dccf', component.options)
    }
    module.hot.accept("./mask.vue?vue&type=template&id=6319dccf&scoped=true&", function () {
      api.rerender('6319dccf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/mask/mask.vue"
export default component.exports